import React, { useState } from "react";
import { TestimonialData } from "./TestimonialData";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import ScrollTrigger from "react-scroll-trigger";

const Testimonial = () => {

  const [animationOn, setAnimationOn] = useState(false);

  return (
    <div className="testimonial">
      <h1 className="mainHeading">Testimonials</h1>
      <p className="mainPara">My Client Say</p>
      <ScrollTrigger
        onEnter={() => setAnimationOn(true)}
        onExit={() => setAnimationOn(false)}
      >
        {animationOn && (
          <Swiper
            className="testimoialContent animate__animated animate__fadeInRight"
            loop={true}
            grabCursor={true}
            spaceBetween={24}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 48,
              },
            }}
            modules={[Pagination]}
          >
            {TestimonialData.map((data) => {
              return (
                <SwiperSlide className="testimonialCard" key={data.id}>
                  <img className="clientImage" src={data.Imag} />
                  <h3 className="clientName">{data.name}</h3>
                  <p className="clientSay">{data.say}</p>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </ScrollTrigger>
    </div>
  );
};

export default Testimonial;
